import React from 'react'
import { Row, Col, Form, Collapse, Input } from 'antd';
import DisplayText from '../_DisplayText'
import { SelectBox, InputBox, isBrowser } from '../../../../shared/custom-ant-d'

const { Panel } = Collapse;

export const PAN = (props) => {
  return (
    <>
      <Collapse defaultActiveKey={['1']} expandIconPosition={'right'}>
        <Panel id='apply-statement' header="Applicant Statement" key="1">
          <Row>
            <Col span={24}>
              <DisplayText
                text={props.getDisplayText('Applicant Statement','PAN Applicant Statement')}
                mode='ellipsis'
              />
            </Col>
          </Row><br />
          <Row>
            <Col md={{ span: 11 }}>
              <Form.Item
                label={<b>{DisplayText(
                  {
                    mode: 'label',
                    text: props.getDisplayText('Applicant Statement','Applicant Agreement'),
                  }
                )}</b>}
                name="applicantStatementAgreeInd"
                rules={[
                  {
                    required: true,
                    message: 'This field is required.',
                  }
                ]}
                initialValue={''}
              >
                <SelectBox
                  data={
                    [
                      { value: 'true', label: 'I Agree' }
                    ]
                  }
                  label={'Response:'}
                  onChange={(value) => {
                    props.resetFieldValues({ applicantStatementAgreeInd: value })
                  }}
                  onDismiss={(value) => {
                    props.resetFieldValues({ applicantStatementAgreeInd: value })
                  }} />
              </Form.Item>
            </Col>
            <Col md={{ span: 11, offset: 1 }}>
              <Form.Item
                label={<b>Please type your full name to sign this application:</b>}
                name="applicantSignature"
                rules={[
                  {
                    required: true,
                    message: 'This field is required',
                  }
                ]}
                initialValue={''}
              >
                {
                  (isBrowser) ?
                    (<Input />) :
                    (<InputBox />)
                }
              </Form.Item>
            </Col>
          </Row>
        </Panel>
      </Collapse>
    </>
  )
}
